/********************************************************************************************************************

 * @file Actions for the tag store

 * @author Thomas Gantt <tg14@licorice.io>

 * @since 2.6.0

 * @date 10-Apr-2025

 *********************************************************************************************************************/

import { createAction } from 'redux-actions';

export const setTags = createAction( 'TAG.TAGS/SET' );